// DS1.7.5
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './ThumbStatusIndicator.scss';
const validCombinations = {
    'in-tier': [
        'large',
        'medium',
        'small'
    ],
    'in-premium': [
        'large',
        'medium'
    ],
    'in-watchers-only': [
        'large',
        'medium'
    ],
    pcp: [
        'medium'
    ],
    nft: [
        'medium'
    ]
};
const fileNameMap = {
    'in-tier': 'tier',
    'in-premium': 'pg',
    'in-watchers-only': 'watchers'
};
const ThumbStatusIndicator = ({ type , size , className  })=>{
    // not all combinations exist
    if (!validCombinations[type].includes(size)) {
        return null;
    }
    var _type;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "",
        className: s['image'],
        src: Url.staticCDNLink(`eclipse/global/svg/deviation-status-icons/${(_type = fileNameMap[type]) !== null && _type !== void 0 ? _type : type}-${size}.svg`)
    }));
};
ThumbStatusIndicator.displayName = 'ThumbStatusIndicator';
export default ThumbStatusIndicator;
